// import React, { useEffect, useState } from "react";
// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css"; 
// import "slick-carousel/slick/slick-theme.css";


// import acerImage from '../../assets/images/Frame 968.png';
// import tclImage from '../../assets/images/Frame 969...png';
// import genarlImage from '../../assets/images/Frame 972.png';
// import goodrejImage from '../../assets/images/Frame 973.png';
// import sellmartDaikinImage from '../../assets/images/Frame 971.png';
// import sellmartLgImage from '../../assets/images/Frame 975.png';
// import sellmartBoschImage from '../../assets/images/Frame 969.png'
// import oppoImage from '../../assets/images/Frame 977.png'
// import loitImage from '../../assets/images/Frame 976.png'
// import whirlpoolImage from '../../assets/images/Frame 97.m1.png'
// import signifyImage from '../../assets/images/Frame 9..68.png'



// // const testimonials = [
// //   {
// //     image: acerImage,
// //   },
// //   {
// //     image: tclImage,
// //   },
// //   {
// //     name: "Sam Wilson",
// //     text: "I love it! Great quality and quick support.",
// //     image: goodrejImage,
// //   },

// //   {
// //     name: "Sam Wilson",
// //     text: "I love it! Great quality and quick support.",
// //     image: sellmartDaikinImage,
// //   },

// //   {
// //     name: "Sam Wilson",
// //     text: "I love it! Great quality and quick support.",
// //     image: oppoImage,
// //   },

// // ];

// const TestimonialSlider = () => {

//   const [testimonials, setPartnerLogos] = useState([]);
// const backendUrl = process.env.REACT_APP_BACKEND_URL;
//   const version = process.env.REACT_APP_VERSION;

//   useEffect(() => {
//     handlePartnersLogo()
    
// },[]);

//   const handlePartnersLogo = async () => {
             
//     try {
//         const response = await fetch(
//             `${backendUrl}api/v2/partners-fetch`,
//             {  method: 'GET',
//               headers:{
//                 // Accept:'aplication/json',
//                 "Content-Type": "application/json",
        
//               },
//               credentials: "include",
//               mode:"cors"
                  
//             }
//         );
//         const data = await response.json();

//         if (data.status && Array.isArray(data.result)) {
//           setPartnerLogos(data.result.map((item:any) => item.logo_img)); // Extract logo_img URLs
//         } else {
//           // console.warn("Unexpected response structure:", data);
//         }
//     } catch (error) {
//         //console.error('Error fetching search results:', error);
//     }
//   }

//   const settings = {
//     dots: false, // Enable navigation dots
//     infinite: true, // Infinite scrolling
//     speed: 700, // Transition speed in milliseconds
//     slidesToShow: 5, // Number of slides to show at once
//     slidesToScroll: 1, // Number of slides to scroll at a time
//     autoplay: true, // Enable autoplay
//     autoplaySpeed: 3000, // Autoplay interval in milliseconds

//     responsive: [
//       {
//         breakpoint: 1024, // For screens less than 1024px
//         settings: {
//           slidesToShow: 3, // Show 3 slides
//           slidesToScroll: 1, // Scroll 1 slide at a time
//         },
//       },
//       {
//         breakpoint: 768, // For screens less than 768px
//         settings: {
//           slidesToShow: 3, // Show 2 slides
//           slidesToScroll: 1,
//         },
//       },
//       {
//         breakpoint: 480, // For screens less than 480px
//         settings: {
//           slidesToShow: 3, // Show 1 slide
//           slidesToScroll: 1,
//         },
//       },
//     ],
//   };

//   return (
//     <div className="testimonial-slider logo_part">
//       <div className="container">
//       <h2 className='headingText' style={{textAlign:"center"}}>Our Partners</h2>
//       <Slider {...settings}>
//         {testimonials.map((testimonial, index) => (
//           <div key={index} className="testimonial">
//             <img
//               src={testimonial}
//               alt={testimonial}
//               className="testimonial-image"
//             />
//           </div>
//         ))}
//       </Slider>
//       </div>
//     </div>
//   );
// };

// export default TestimonialSlider;





import LogoCarousel from "./LogoCarousel";

const TestimonialSlider = () => {
  const backendUrl = process.env.REACT_APP_BACKEND_URL!;
  return (
    <LogoCarousel
      title="Our Partners"
      apiEndpoint="api/v2/partners-fetch"
      backendUrl={backendUrl}
    />
  );
};

export default TestimonialSlider;
